import { onMounted } from 'vue'
import { useRoute } from 'vue-router'

import { useI18nAddon } from '@/i18n/i18n'
import { getDevtools } from '@/modules/devtools'
import { useAdBlockStore } from '@/store/ad-block-store'
import { useAdDisabledStore } from '@/store/ad-disabled-store'
import { useAppStore } from '@/store/app-store'
import { useClientAppStore } from '@/store/client-app-store'
import { useUserStore } from '@/store/user-store/user-store'

export function usePageDevtoolsPanel() {
    const appStore = useAppStore()
    const clientAppStore = useClientAppStore()
    const userStore = useUserStore()
    const adBlockStore = useAdBlockStore()
    const adDisabledStore = useAdDisabledStore()
    const { currentLocale } = useI18nAddon()
    const route = useRoute()

    onMounted(() => {
        getDevtools()?.addPanel(
            () =>
                import('@/modules/devtools/panels/page/page-panel').then(({ pageDevtoolsPanel }) =>
                    pageDevtoolsPanel(() => ({
                        page: route.name?.toString(),
                        platform: appStore.platform,
                        clientType: appStore.clientType,
                        countryCode: appStore.countryCode,
                        locale: currentLocale.value,
                        isAuthorized: userStore.isAuthorized,
                        isCompanyEmployee: userStore.isCompanyEmployeeLoggedIn,
                        userId: userStore.user?._id,
                        auid: clientAppStore.auid,
                        clid: appStore.clid,
                        widgetId: clientAppStore.widgetId,
                        appVersion: appStore.appVersion,
                        isAdDisabled: adDisabledStore.isAdDisabled,
                        adBlockStatus: adBlockStore.adBlockStatus,
                        experiments: Object.entries(appStore.experimentsRaw || {}).map(([name, { sample }]) => ({
                            name,
                            sample,
                            isApplied: !!(appStore.experiments as Record<string, unknown>)[name],
                        })),
                    })),
                ),
            'full',
        )
    })
}
